import React from "react";

const STYLES = {
  DRAFT: "bg-gray-100 dark:bg-neutral-900 text-gray-700 dark:text-neutral-200",
  APPROVED: "bg-blue-100 text-blue-700",
  PUBLISHED: "bg-green-100 text-green-700",
  LOCKED: "bg-purple-100 text-purple-700",
};

export default function PayrollStatusBadge({ status }) {
  const s = (status || "DRAFT").toUpperCase();
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
        STYLES[s] || STYLES.DRAFT
      }`}
    >
      {s}
    </span>
  );
}
